import type { ReactNode } from 'react';
import type { ButtonType } from 'antd/es/button/buttonHelpers';
import type { IFormDrawerProps, TFormDrawerGenericType } from 'components/common/form-drawer';

export enum EFormDrawerWithButtonIconType {
  CREATE = 'create',
  EDIT = 'edit',
  NONE = 'none',
}

export interface IFormDrawerWithButtonProps<T extends TFormDrawerGenericType>
  extends Omit<IFormDrawerProps<T>, 'isOpen' | 'onClose' | 'formInstance'> {
  buttonLabel?: ReactNode;
  iconType?: EFormDrawerWithButtonIconType;
  buttonType?: ButtonType;
  buttonDisabled?: boolean;
  preventCloseOnFinish?: boolean;
  onClose?: () => void;
}
